module.exports = __webpack_public_path__ + "static/img/tiggy_pictgrid30_1080x735.4a5ecbc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/tiggy_pictgrid30_1080x735.jpg
// module id = TjWc
// module chunks = 0